import * as React from 'react';
import { useChatInputEntity_unstable } from './useChatInputEntity';
import { renderChatInputEntity_unstable } from './renderChatInputEntity';
import { useChatInputEntityStyles_unstable } from './useChatInputEntityStyles.styles';
import type { ChatInputEntityProps } from './ChatInputEntity.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

// ChatInputEntity component - TODO: add more docs
export const ChatInputEntity: ForwardRefComponent<ChatInputEntityProps> = React.forwardRef((props, ref) => {
  const state = useChatInputEntity_unstable(props, ref);

  useChatInputEntityStyles_unstable(state);
  return renderChatInputEntity_unstable(state);
});

ChatInputEntity.displayName = 'ChatInputEntity';
